<template>
  <div class="">
    <h2 class="font-weight-bold">
      <v-icon large>{{ icon }}</v-icon> {{ text }}
    </h2>
  </div>
</template>

<script>
export default {
  name: "PageTitle",
  props: {
    icon: { type: String },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped></style>
